import { tempoApi } from '@/common/api/tempoApi';
import type { Skill } from '@/common/api/types/skills';

export type SkillSearchParams = {
  query?: string;
  isCritical?: boolean;
};

const getSkills = async (): Promise<Skill[]> => {
  const response = await tempoApi().get('api/v1/capacity/skills').json<{ data: Skill[] }>();
  return response.data;
};

const createSkillsBulk = async (
  skills: Array<{ name: string; isCritical?: boolean }>,
): Promise<Skill[]> => {
  return await tempoApi()
    .post('api/v1/capacity/skills/bulk', {
      json: {
        skills,
      },
    })
    .json<Skill[]>();
};

const updateSkill = async (id: number, name: string, isCritical: boolean): Promise<Skill> => {
  return await tempoApi()
    .put(`api/v1/capacity/skills/${id}`, {
      json: {
        name,
        isCritical,
      },
    })
    .json<Skill>();
};

const searchSkills = async ({
  query = '',
  isCritical,
}: SkillSearchParams = {}): Promise<Skill[]> => {
  const response = await tempoApi()
    .get('api/v1/capacity/skills/search', {
      searchParams: {
        query,
        ...(isCritical !== undefined && { isCritical }),
      },
    })
    .json<{ data: Skill[] }>();
  return response.data;
};

const deleteSkill = async (id: number): Promise<void> => {
  await tempoApi().delete(`api/v1/capacity/skills/${id}`);
};

export const SkillsApi = {
  getSkills,
  searchSkills,
  createSkillsBulk,
  updateSkill,
  deleteSkill,
};
